export const meleeData = Object.freeze({
  'Baseball Bat (1 hand)': {
    Name: 'Baseball Bat (1 hand)',
    ws: '2.5',
    wc: '1',
    IDc: '(4)+2',
    IDs: '(3)',
    Rng: '2',
  },
  'Baseball Bat (2 hands)': {
    Name: 'Baseball Bat (2 hands)',
    ws: '2.6',
    wc: '1',
    IDc: '(10)+3',
    IDs: '(5)',
    Rng: '2',
  },
  'Billy Club': {
    Name: 'Billy Club',
    ws: '2.8',
    wc: '2',
    IDc: '(3)+1',
    IDs: '(3)',
    Rng: '1',
  },
  'Crowbar (1 hand)': {
    Name: 'Crowbar (1 hand)',
    ws: '2.3',
    wc: '0',
    IDc: '(6)+2',
    IDs: '(3)',
    Rng: '1',
  },
  'Crowbar (2 hands)': {
    Name: 'Crowbar (2 hands)',
    ws: '2.4',
    wc: '0',
    IDc: '(10)+4',
    IDs: '(5)',
    Rng: '1',
  },
  'Entrenching Tool (1 hand)': {
    Name: 'Entrenching Tool (1 hand)',
    ws: '2.5',
    wc: '-1',
    IDc: '(3)+3',
    IDs: '(3)',
    Rng: '1',
  },
  'Entrenching Tool (2 hands)': {
    Name: 'Entrenching Tool (2 hands)',
    ws: '2.6',
    wc: '-1',
    IDc: '(5)+5',
    IDs: '(4)',
    Rng: '1',
  },
  'Heavy Rifle': {
    Name: 'Heavy Rifle',
    ws: '1.8',
    wc: '-2',
    IDc: '(8)+3',
    IDs: '(6)+3',
    Rng: '2+',
  },
  'Hammer (1 hand)': {
    Name: 'Hammer (1 hand)',
    ws: '2.6',
    wc: '-1',
    IDc: '(3)+3',
    IDs: '(3)',
    Rng: '1',
  },
  'Hammer (2 hands)': {
    Name: 'Hammer (2 hands)',
    ws: '2.7',
    wc: '-1',
    IDc: '(6)+3',
    IDs: '(3)',
    Rng: '1',
  },
  'Hatchet (1 hand)': {
    Name: 'Hatchet (1 hand)',
    ws: '2.3',
    wc: '-1',
    IDc: '(4)+3',
    IDs: '(3)',
    Rng: '1',
  },
  'Hatchet (2 hands)': {
    Name: 'Hatchet (2 hands)',
    ws: '2.3',
    wc: '-1',
    IDc: '(6)+5',
    IDs: '(4)',
    Rng: '1',
  },
  'Ice Pick': {
    Name: 'Ice Pick',
    ws: '2.9',
    wc: '+2',
    IDc: '-',
    IDs: '(3)',
    Rng: '1',
  },
  'Katana (1 hand)': {
    Name: 'Katana (1 hand)',
    ws: '2.1',
    wc: '0',
    IDc: '(5)+2',
    IDs: '(3)',
    Rng: '2',
  },
  'Katana (2 hands)': {
    Name: 'Katana (2 hands)',
    ws: '2.2',
    wc: '0',
    IDc: '(10)+4',
    IDs: '(5)',
    Rng: '2',
  },
  'Knife, Bowie': {
    Name: 'Knife, Bowie',
    ws: '2.8',
    wc: '2',
    IDc: '(3)+2',
    IDs: '(3)',
    Rng: '1',
  },
  'Knife, Combat': {
    Name: 'Knife, Combat',
    ws: '2.8',
    wc: '2',
    IDc: '(3)+1',
    IDs: '(3)',
    Rng: '1',
  },
  'Knife, Switch Blade': {
    Name: 'Knife, Switch Blade',
    ws: '2.9',
    wc: '2',
    IDc: '(2)+1',
    IDs: '(3)',
    Rng: '1',
  },
  'Light Rifle': {
    Name: 'Light Rifle',
    ws: '1.9',
    wc: '-1',
    IDc: '(6)+3',
    IDs: '(6)+2',
    Rng: '2+',
  },
  'Machete (1 hand)': {
    Name: 'Machete (1 hand)',
    ws: '2.3',
    wc: '0',
    IDc: '(6)+2',
    IDs: '(3)',
    Rng: '1',
  },
  'Machete (2 hands)': {
    Name: 'Machete (2 hands)',
    ws: '2.4',
    wc: '0',
    IDc: '(10)+3',
    IDs: '(3)',
    Rng: '1',
  },
  'Pipe, 24" (1 hand)': {
    Name: 'Pipe, 24" (1 hand)',
    ws: '2.5',
    wc: '0',
    IDc: '(4)+2',
    IDs: '(3)',
    Rng: '1+',
  },
  'Pipe, 24" (2 hands)': {
    Name: 'Pipe, 24" (2 hands)',
    ws: '2.6',
    wc: '0',
    IDc: '(10)+3',
    IDs: '(4)',
    Rng: '1+',
  },
  Pistol: {
    Name: 'Pistol',
    ws: '2.4',
    wc: '0',
    IDc: '(6)+3',
    IDs: '-',
    Rng: '1',
  },
  Rock: {
    Name: 'Rock',
    ws: '2.6',
    wc: '0',
    IDc: '(6)+2',
    IDs: '-',
    Rng: '1',
  },
  Saber: {
    Name: 'Saber',
    ws: '2.3',
    wc: '0',
    IDc: '(5)+2',
    IDs: '(3)',
    Rng: '2+',
  },
  'Scimitar (1 hand)': {
    Name: 'Scimitar (1 hand)',
    ws: '2.0',
    wc: '0',
    IDc: '(6)+3',
    IDs: '(3)',
    Rng: '2+',
  },
  'Scimitar (2 hands)': {
    Name: 'Scimitar (2 hands)',
    ws: '2.1',
    wc: '0',
    IDc: '(10)+3',
    IDs: '(5)',
    Rng: '2+',
  },
  SMG: {
    Name: 'SMG',
    ws: '2.0',
    wc: '-1',
    IDc: '(6)',
    IDs: '(6)+1',
    Rng: '2',
  },
  'Stick (1 hand)': {
    Name: 'Stick (1 hand)',
    ws: '2.5',
    wc: '0',
    IDc: '(4)+2',
    IDs: '(3)',
    Rng: '2',
  },
  'Stick (2 hands)': {
    Name: 'Stick (2 hands)',
    ws: '2.6',
    wc: '0',
    IDc: '(10)+5',
    IDs: '(5)',
    Rng: '2',
  },
  'Two by Four (1 hand)': {
    Name: 'Two by Four (1 hand)',
    ws: '2.4',
    wc: '0',
    IDc: '(5)+2',
    IDs: '(3)',
    Rng: '2',
  },
  'Two by Four (2 hands)': {
    Name: 'Two by Four (2 hands)',
    ws: '2.5',
    wc: '0',
    IDc: '(8)+4',
    IDs: '(5)',
    Rng: '2',
  },
  'Wood Axe (2 hands)': {
    Name: 'Wood Axe (2 hands)',
    ws: '1.7',
    wc: '-2',
    IDc: '(10)+6',
    IDs: '(5)',
    Rng: '2',
  },
});

export const weaponSpeedActionCosts = Object.freeze([
  { ws: 1, parry: 3, set: 3, strike: 1, rec: 3 },
  { ws: 1.2, parry: 2, set: 2, strike: 1, rec: 2 },
  { ws: 1.5, parry: 1, set: 2, strike: 1, rec: 2 },
  { ws: 1.8, parry: 1, set: 2, strike: 1, rec: 1 },
  { ws: 2.3, parry: 1, set: 1, strike: 1, rec: 1 },
  { ws: 3.1, parry: 1, set: 2, strike: 0.5, rec: 0.5 },
]);
